import { LogLevel } from "@azure/msal-browser";
import { Environment } from "../interfaces/Environment";

export const environment: Environment = {
    production: false,
    msal: {
        auth: {
            clientId: "998b6b99-dc25-41ee-adcf-12842239c50c",
            authority: "https://login.microsoftonline.com/372ee9e0-9ce0-4033-a64a-c07073a91ecd",
            redirectUri: "http://localhost:3000",
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false, // set to "true" if issues on IE11/Edge
        },
        system: {
            loggerOptions: {
                loggerCallback: (level: LogLevel, message: string, containsPii: any) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        default:
                            return;
                    }
                }
            }
        }
    },
    api: {
        getAvailableFAInfoAndChatName: "https://prod-110.westeurope.logic.azure.com:443/workflows/4ce647c1b7184a7eb3291c57baee9709/triggers/manual/paths/invoke?api-version=2016-10-01",
        callForHelp: "https://prod-40.westeurope.logic.azure.com:443/workflows/d3a57de3c508410e981787522a2809e3/triggers/manual/paths/invoke?api-version=2016-10-01",
        cancelCallForHelp: "https://prod-27.westeurope.logic.azure.com:443/workflows/21051cbe600f44e489101cf83eed2aef/triggers/manual/paths/invoke?api-version=2016-10-01",
        HC: "https://prod-86.westeurope.logic.azure.com:443/workflows/6d9342d6ada24e46806ec4699b89b302/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=RHHRx-rTKfGKsp6ljILIUsDZB3KmCuKFbuSqyFlfO0c"
    },
    storageInformation: {
        accountName: 'firstaidersdevstorage',
        tableName: 'firstAidersList',
    },
    serviceAccountId: "d04079c2-c0fc-4bd3-aeb2-b65dde0f7756"
}